/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

/* eslint id-length: 0 */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var ExpandingMenu = (function (_Component) {
	_inherits(ExpandingMenu, _Component);

	_createClass(ExpandingMenu, null, [{
		key: 'propTypes',
		value: {
			'children': _react.PropTypes.object,
			'className': _react.PropTypes.string,
			'icon': _react.PropTypes.string,
			'isMenu': _react.PropTypes.bool,
			'label': _react.PropTypes.string,
			'links': _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]),
			'menuPosition': _react.PropTypes.string,
			'narrowLabel': _react.PropTypes.bool,
			'rootURI': _react.PropTypes.string,
			'selected': _react.PropTypes.string,
			'seeAllLink': _react.PropTypes.string
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			'isMenu': true,
			'label': 'Label me!',
			'links': {},
			'menuPosition': 'alignLeft',
			'narrowLabel': false,
			'rootURI': 'section',
			'seeAllLink': '',
			'selected': 'home'
		},
		enumerable: true
	}]);

	function ExpandingMenu(props) {
		_classCallCheck(this, ExpandingMenu);

		_Component.call(this, props);
		this.state = {
			'isOpen': false
		};
		this.onDocumentClick = this.onDocumentClick.bind(this);
	}

	ExpandingMenu.prototype.componentDidMount = function componentDidMount() {
		document.addEventListener('click', this.onDocumentClick);
	};

	ExpandingMenu.prototype.componentWillUnmount = function componentWillUnmount() {
		document.removeEventListener('click', this.onDocumentClick);
	};

	ExpandingMenu.prototype.onDocumentClick = function onDocumentClick(event) {
		var toggle = _reactDom2['default'].findDOMNode(this.refs.toggle);
		var menu = _reactDom2['default'].findDOMNode(this.refs.menu);

		if (toggle && toggle.contains(event.target)) {
			this.setState({ 'isOpen': !this.state.isOpen });
			event.preventDefault();
		} else if (menu && !menu.contains(event.target)) {
			this.setState({ 'isOpen': false });
		}
	};

	ExpandingMenu.prototype.render = function render() {
		var _classNames2,
		    _classNames3,
		    _this = this;

		var styles = require('./ExpandingMenu.css');
		var _props = this.props;
		var children = _props.children;
		var className = _props.className;
		var icon = _props.icon;
		var isMenu = _props.isMenu;
		var label = _props.label;
		var links = _props.links;
		var menuPosition = _props.menuPosition;
		var narrowLabel = _props.narrowLabel;
		var rootURI = _props.rootURI;
		var selected = _props.selected;

		/* Build menu items from `links` array */
		var menuItems = _lodash2['default'].map(links, function (item, id) {
			var _classNames;

			var linkStyles = _classnames2['default']((_classNames = {}, _classNames[styles.MenuLink] = true, _classNames[styles['MenuLink--here']] = selected === id, _classNames));

			return _react2['default'].createElement(
				'li',
				{ className: styles.MenuItem, key: id },
				_react2['default'].createElement(_reactRouter.Link, {
					activeClassName: styles['MenuLink--here'],
					className: linkStyles,
					dangerouslySetInnerHTML: { __html: item.name || item.title.rendered },
					onClick: function () {
						_this.setState({ 'isOpen': false });
					},
					to: rootURI + '/' + item.slug })
			);
		});

		/* Classes for all nav elements contained here */
		var toggleStyles = _classnames2['default']((_classNames2 = {}, _classNames2[styles.Toggle] = true, _classNames2[styles['Toggle--here']] = this.state.isOpen, _classNames2[styles['Toggle--withIcon']] = icon, _classNames2[styles['Toggle--narrow']] = narrowLabel, _classNames2));

		var menuStyles = _classnames2['default']((_classNames3 = {}, _classNames3[styles.Menu] = true, _classNames3[styles['Menu--withIcon']] = icon, _classNames3[styles['Menu--' + menuPosition]] = true, _classNames3[styles['Menu--withColumns']] = isMenu, _classNames3));

		return _react2['default'].createElement(
			'nav',
			{ className: (className ? className + ' ' : null) + styles.Nav },
			_react2['default'].createElement(
				'a',
				{ className: toggleStyles, href: rootURI, ref: 'toggle' },
				icon ? _react2['default'].createElement('i', { className: styles.ToggleIcon }) : null,
				label
			),
			this.state.isOpen && isMenu && _react2['default'].createElement(
				'div',
				{ className: menuStyles },
				this.props.seeAllLink ? _react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.SeeAllLink, to: this.props.seeAllLink },
					'See All'
				) : null,
				_react2['default'].createElement(
					'ul',
					{ className: styles.MenuList, ref: 'menu' },
					menuItems
				)
			),
			this.state.isOpen && !isMenu && _react2['default'].createElement(
				'div',
				{ className: menuStyles, ref: 'menu' },
				_react2['default'].createElement(
					'div',
					{ className: styles.TextContent, onClick: function () {
							_this.setState({ 'isOpen': false });
						} },
					children
				)
			)
		);
	};

	return ExpandingMenu;
})(_react.Component);

exports['default'] = ExpandingMenu;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ExpandingMenu/ExpandingMenu.js
 ** module id = 677
 ** module chunks = 0
 **/